export default __webpack_public_path__ + "static/media/vnu-cet-logo.31a5d5c0.png";